import { useState } from 'react';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { EditUserModal } from '../EditUserModal/EditUserModal';
import { TIntroducerListItem } from '../UsersTable.types';
import { RowActionsMenu } from './RowActionsMenu';

type TProps = {
  user: TIntroducerListItem;
};

export const ActionsCell = ({ user }: TProps) => {
  const { introducer } = useIntroducerData();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Gate on the introducer resolving so isSelf is definitive before the modal
  // mounts — otherwise a master broker editing their own row could land on the
  // unguarded form for one render and self-revoke `Manage users`.
  if (!introducer) return null;

  const isSelf = introducer.id === user.id;

  return (
    <>
      <RowActionsMenu onEdit={() => setIsModalOpen(true)} />
      {isModalOpen && (
        <EditUserModal
          user={user}
          isSelf={isSelf}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
